<template>
  <div id="versionItem" :myProjectsSearchId="myProjectsSearchId">
    <section class="con-wrapper">
      <h1 :class="!versionHistoryData.length ? 'opacityVersion' : ''">{{ $t('myprojectsList.version.title') }}</h1>
      <el-collapse :accordion="true" v-loading="loading" v-model="activeNames" @change="handleChange">
        <div
          v-for="(o, i) in versionHistoryData"
          :key="i"
          style="position: relative;margin-bottom: 70px;"
        >
          <el-collapse-item :title="titleItem(o.versionName)" :name="i">
            <div class="showMore" @click="showMoreVersion(o)">{{ $t('myprojectsList.version.collapse .more') }}</div>
            <app-view-item :versionItem="o"></app-view-item>
          </el-collapse-item>
        </div>
      </el-collapse>
    </section>
    <div v-show="!versionHistoryData.length">
        <h4 class="noVersionData" :class="!versionHistoryData.length ? 'opacityVersion' : ''">{{ $t('myprojectList.version.common.noVersion') }}</h4>
    </div>
  </div>
</template>

<script>
import AppViewItem from './appViewItem'
// fu
export default {
    data () {
        return {
            versionHistoryData: [],
            activeNames: '',
            appId: '',
            loading: false
            // ,code: ''
        }
    },
    components: {
        'app-view-item': AppViewItem
    },
    mounted () {
        let secondNavItem = [
            { path: 'MyProjectsEdit', msg: 'header.secondFloor.route.name.process' },
            true,
            { path: 'MyProjectsVersion', msg: 'header.secondFloor.route.name.versionHst' }
        ]
        this.$store.state.secondNavItem = secondNavItem
        // this.appId = this.$store.state.versionHistoryId
        // if (!this.appId) {
        this.appId = localStorage.getItem('appId')
        // this.$store.state.versionHistoryId = this.appId
        // }
        this.getVersionInfo(this.appId)
    },
    methods: {
        handleChange () {},
        getVersionInfo (appId) {
            this.loading = true
            // const { title, message, status, publishAfterDate } = this
            const path = `/developer/app/${appId}/version`
            // let body = { ...this.form }
            this._api.request('get', path)
                .then(response => {
                    this.loading = false
                    const data = response.data.data.payload
                    this.versionHistoryData = data
                    // this.code = data[0].versionCode
                    // this.appVerInfo = response.data.data.payload
                })
                .catch(error => {
                    this.loading = false
                    this.versionHistoryData = []
                    console.log(error)
                })
        },
        titleItem (title) {
            return `${this.$t('myprojectsList.common.title')}${title}`
        },
        showMoreVersion (o) {
            sessionStorage.setItem('verCode', o.versionCode)
            this.$router.push({
                name: 'MyProjectsVersionDetail',
                params: {
                    id: this.appId,
                    code: o.versionCode
                }
            })
        }
    },
    computed: {
        myProjectsSearchId () {
            let { key, val } = this.$store.state.myProjectsSearchId
            if (key === 'MyProjectsVersion') {
                this.appId = val
                // localStorage.setItem('appId', val)
                this.getVersionInfo(val)
            }
            return this.$store.state.myProjectsSearchId
        }
    },
    watch: {
        versionHistoryData () {
            return this.versionHistoryData
        }
    }
}
</script>

<style scoped>
h1,
h3 {
    margin: 0px;
}
#versionItem {
    font-family: sans-serif;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 1.1px;
    color: #333333;
    overflow: hidden;
    padding-bottom: 130px;
}
#versionItem a {
    color: #00b5e2;
}
#versionItem h1 {
    height: 56px;
    font-size: 38px;
    font-weight: 500;
    letter-spacing: 2.1px;
    margin: 18px 0px 40px 0px;
}
.opacityVersion{
    opacity: .5;
}
.noVersionData{
    display: flex;
    justify-content: center;
    margin: auto;
    height: 24px;
    font-family: sans-serif;
    font-size: 16px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.9px;
    color: #333333;
}
.showMore {
    position: absolute;
    color: #00b5e2;
    right: 0px;
    width: 152px;
    height: 30px;
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    top: 12px;
}
.con-wrapper {
    max-width: 897px;
    margin: 0px auto;
    position: relative;
}
</style>
<style>
#versionItem .el-collapse-item__header {
    display: flex;
    font-size: 20px;
    font-weight: 500;
    border: none;
}
#versionItem .el-collapse-item__arrow.is-active {
    font-weight: bold;
    color: #00b5e2;
    border: none;
}
#versionItem .el-collapse-item__arrow {
    font-weight: bold;
    color: #00b5e2;
    border: none;
}
#versionItem .el-collapse,
#versionItem .el-collapse-item__wrap {
    border: none !important;
}
</style>
